import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import './App.css';
// Q6t62QwXSyRusRufl0KeAdTs7iM2
/**
{
  "cardId": "1071580348",
  "idType": "CC",
  "phoneNumber": "3197807871",
  "name": "Milton Horacio Chávez Aguirre",
  "address": {
    "address": "Calle 71A#71-38",
    "city": "Bogotá",
  },
  "email": "miltonx93@gmail.com",
  "features": [
    {
      "key": "program",
      "value": "Administrative Support in Clinical Settings (STC)"
    },
    {
      "key": "origin",
      "value": "access"
    },
  ]
}
 */

function sendData(data) {
    console.log('data to send', data);
    const url = `https://centauriproapi.azurewebsites.net/marketplace/Callback/customer/centauri/Q6t62QwXSyRusRufl0KeAdTs7iM2`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    };
    return fetch(url, requestOptions)
        .then((res) => res);
}

function Copyright({ companyName, website }, props) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href={website}>
                {companyName}
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const theme = createTheme();
function ComplexForm() {

    const [loading, setLoading] = React.useState(false);
    const [sent, setSent] = React.useState(false);
    const title = 'Canadá te espera';
    const subtitle = 'Inicia aquí tu proceso de aceptación al College. ¡Te esperamos pronto en Canadá!';
    
    function removeAccentsAndCapitalize(str) {
        if(!str){
            return str;
        }

        const accentsMap = {
          'á': 'a', 'à': 'a', 'ã': 'a', 'â': 'a', 'ä': 'a', 'Á': 'A', 'À': 'A', 'Ã': 'A', 'Â': 'A', 'Ä': 'A',
          'é': 'e', 'è': 'e', 'ê': 'e', 'ë': 'e', 'É': 'E', 'È': 'E', 'Ê': 'E', 'Ë': 'E',
          'í': 'i', 'ì': 'i', 'î': 'i', 'ï': 'i', 'Í': 'I', 'Ì': 'I', 'Î': 'I', 'Ï': 'I',
          'ó': 'o', 'ò': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o', 'Ó': 'O', 'Ò': 'O', 'Ô': 'O', 'Õ': 'O', 'Ö': 'O',
          'ú': 'u', 'ù': 'u', 'û': 'u', 'ü': 'u', 'Ú': 'U', 'Ù': 'U', 'Û': 'U', 'Ü': 'U',
          'ç': 'c', 'Ç': 'C',
          'ñ': 'n', 'Ñ': 'N'
        };
      
        return str
          .split('')
          .map(char => accentsMap[char] || char)
          .join('')
          .toUpperCase();
      }

    const inputs = [
        {
            name: 'email',
            label: 'Correo electrónico',
            type: 'email',
            required: true,
            autoComplete: 'email',
            autoFocus: true,
        },
        {
            name: 'name',
            label: 'Nombres',
            type: 'text',
            required: true,
            autoComplete: 'name',
            autoFocus: false,
        },
        {
            name: 'lastName',
            label: 'Apellidos',
            type: 'text',
            required: true,
            autoComplete: 'name',
            autoFocus: false,
        },
        {
            name: 'sex',
            label: 'Sexo',
            type: 'select',
            required: true,
            autoComplete: 'sex',
            autoFocus: false,
            options: [
                {
                    value: 'M',
                    label: 'Masculino',
                },
                {
                    value: 'F',
                    label: 'Femenino',
                },
                {
                    value: 'NA',
                    label: 'Otro',
                }
            ]
        },
        {
            name: 'language',
            label: 'Idioma deseado del programa',
            type: 'select',
            required: true,
            autoComplete: 'language',
            autoFocus: false,
            options: [
                {
                    value: 'Ingles',
                    label: 'Inglés',
                },
                {
                    value: 'Frances',
                    label: 'Francés',
                }
            ]
        },
        {
            name: 'birthPlace',
            label: 'Ciudad de nacimiento',
            type: 'text',
            required: true,
            autoComplete: 'birth-place',
            autoFocus: false,
        },
        {
            name: 'birthCountry',
            label: 'País de nacimiento',
            type: 'select',
            required: true,
            autoComplete: 'country',
            autoFocus: false,
            options: [
                {
                    value: 'Colombia',
                    label: 'Colombia',
                },
                {
                    value: 'Peru',
                    label: 'Perú',
                },
                {
                    value: 'Ecuador',
                    label: 'Ecuador',
                },
                {
                    value: 'Venezuela',
                    label: 'Venezuela',
                },
                {
                    value: 'Chile',
                    label: 'Chile',
                },
                {
                    value: 'Argentina',
                    label: 'Argentina',
                },
                {
                    value: 'Bolivia',
                    label: 'Bolivia',
                },
                {
                    value: 'Paraguay',
                    label: 'Paraguay',
                },
                {
                    value: 'Uruguay',
                    label: 'Uruguay',
                },
                {
                    value: 'Brasil',
                    label: 'Brasil',
                },
                {
                    value: 'Otro',
                    label: 'Otro',
                }
            ]
        },
        {
            name: 'program',
            label: 'Programa',
            type: 'select',
            required: true,
            autoComplete: 'off',
            autoFocus: false,
            options: [
                {
                    value: 'ASP Secretariat Juridique',
                    label: 'ASP Secretariat Juridique',
                },
                {
                    value: 'ASP Secretariat Medical',
                    label: 'ASP Secretariat Medical',
                },
                {
                    value: 'DEP / ASP Secretariat Medical',
                    label: 'DEP / ASP Secretariat Medical',
                },
                {
                    value: 'DEP / ASP Secretariat Juridique',
                    label: 'DEP / ASP Secretariat Juridique',
                },
                {
                    value: 'DEP Accounting',
                    label: 'DEP Accounting',
                }
            ]
        },
        {
            name: 'studies',
            label: 'Nivel de estudios',
            type: 'select',
            required: true,
            autoComplete: 'off',
            autoFocus: false,
            options: [
                {
                    value: 'High school Diploma',
                    label: 'Bachillerato',
                },
                {
                    value: 'DEC',
                    label: 'Diploma de Educación Superior',
                },
                {
                    value: 'DEP/DVS',
                    label: 'Diploma de Educación Técnica',
                },
                {
                    value: 'Other/ Autre',
                    label: 'Otro',
                }
            ]
        },
        {
            name: 'address',
            label: 'Dirección',
            type: 'text',
            required: true,
            autoComplete: 'address-line1',
            autoFocus: false,
        },
        {
            name: 'city',
            label: 'Ciudad de residencia',
            type: 'text',
            required: true,
            autoComplete: 'address-level2',
            autoFocus: false,
        },
        {
            name: 'country',
            label: 'País de residencia',
            type: 'select',
            required: true,
            autoComplete: 'country',
            autoFocus: false,
            options: [
                {
                    value: 'Colombia',
                    label: 'Colombia',
                },
                {
                    value: 'Peru',
                    label: 'Perú',
                },
                {
                    value: 'Ecuador',
                    label: 'Ecuador',
                },
                {
                    value: 'Venezuela',
                    label: 'Venezuela',
                },
                {
                    value: 'Chile',
                    label: 'Chile',
                },
                {
                    value: 'Argentina',
                    label: 'Argentina',
                },
                {
                    value: 'Bolivia',
                    label: 'Bolivia',
                },
                {
                    value: 'Paraguay',
                    label: 'Paraguay',
                },
                {
                    value: 'Uruguay',
                    label: 'Uruguay',
                },
                {
                    value: 'Brasil',
                    label: 'Brasil',
                },
                {
                    value: 'Otro',
                    label: 'Otro',
                }
            ]
        },
        {
            name: 'phone',
            label: 'Teléfono',
            type: 'tel',
            required: true,
            autoComplete: 'tel',
            autoFocus: false,
        },
        {
            name: 'birthDay',
            label: 'Fecha de nacimiento',
            type: 'date',
            required: true,
            autoComplete: 'bday',
            autoFocus: false,
            shrink: true,
        },
        {
            name: 'startDate',
            label: 'Fecha deseada de inicio de estudios',
            type: 'select',
            required: true,
            autoComplete: 'startDate',
            autoFocus: false,
            shrink: true,
            options: [
                {
                    value: 'JN 2023',
                    label: 'Junio de 2023',
                },
                {
                    value: 'OC 2023',
                    label: 'Octubre de 2023',
                },
                {
                    value: 'JA 2024',
                    label: 'Enero de 2024',
                },
                {
                    value: 'MR 2024',
                    label: 'Marzo de 2024',
                },
                {
                    value: 'JN 2024',
                    label: 'Junio de 2024',
                }
            ]
        },
        {
            name: 'fatherName',
            label: 'Nombres y apellidos de tu padre',
            type: 'text',
            required: true,
            autoComplete: 'father-name',
            autoFocus: false,
        },
        {
            name: 'motherName',
            label: 'Nombres y apellidos de tu madre',
            type: 'text',
            required: true,
            autoComplete: 'mother-name',
            autoFocus: false,
        },
    ];



    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        inputs.forEach(input => {
            console.log(input.name, data.get(input.name));
        });

        const payload = {
            "name": removeAccentsAndCapitalize(data.get('name')) + '-' + removeAccentsAndCapitalize(data.get('lastName')),
            "features": [
                {
                    "key": "motherLanguage",
                    "value": data.get('birthCountry') === 'Brasil' ? 'PORTUGUES' : 'ESPANOL'
                },
                {
                    "key": "sex",
                    "value": data.get('sex')
                },
                {
                    "key": "language",
                    "value": data.get('language')
                },
                {
                    "key": "birthPlace",
                    "value": removeAccentsAndCapitalize(data.get('birthPlace'))
                },
                {
                    "key": "birthCountry",
                    "value": removeAccentsAndCapitalize(data.get('birthCountry'))
                },
                {
                    "key": "fatherName",
                    "value": removeAccentsAndCapitalize(data.get('fatherName'))
                },
                {
                    "key": "motherName",
                    "value": removeAccentsAndCapitalize(data.get('motherName'))
                },
                {
                    "key": "program",
                    "value": data.get('program')
                },
                {
                    "key": "startDate",
                    "value": data.get('startDate')
                },
                {
                    "key": "range",
                    "value": removeAccentsAndCapitalize(data.get('range'))
                },
                {
                    "key": "studies",
                    "value": removeAccentsAndCapitalize(data.get('studies'))
                },
                {
                    "key": "signature",
                    "value": removeAccentsAndCapitalize(data.get('name') + ' ' + data.get('lastName'))
                },
                {
                    "key": "origin",
                    "value": "csm_auto"
                }
            ],
            "address": {
                "address": removeAccentsAndCapitalize(data.get('address')),
                "addressDetail": ".",
                "region": removeAccentsAndCapitalize(data.get('region')),
                "zipCode": removeAccentsAndCapitalize(data.get('zipCode')),
                "city": removeAccentsAndCapitalize(data.get('city')),
                "country": removeAccentsAndCapitalize(data.get('country'))
            },
            "phoneNumber": data.get('phone'),
            "emergencyPhone": data.get('phone'),
            "birthDay": data.get('birthDay'),
            "email": data.get('email')
        };

        // all fields are required, check all
        if (!inputs.every(input => data.get(input.name))) {
            alert('Por favor, completa todos los campos');
            return;
        }
        

        setLoading(true);
        sendData(payload).then(() => {
            setLoading(false);
            setSent(true);
        }
        );
    };
    return (<ThemeProvider theme={theme}>
        <Grid container component="main" sx={{ height: '100vh' }}>
            <CssBaseline />
            <Grid
                item
                xs={false}
                sm={4}
                md={7}
                sx={{
                    backgroundImage: 'url(https://source.unsplash.com/random?montreal)',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: (t) =>
                        t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            />
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <Box
                    sx={{
                        mt: 0,
                        mb: 8,
                        mx: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >

                    {/* <img height={'96px'} src={"/static/logo-doble-1.png"} alt="Canadá College" /> */}
                    <Box sx={{
                        background: "#ffffff", width: '100%', p: '20px', display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}>
                        <img height={'64px'} src={"./static/cropped-college-superieur-montreal-logo.png"} alt="CSM" />
                    </Box>
                    <Box sx={{ mx: 4 }}>
                        <Typography sx={{ mb: '20px', mt: '20px', textAlign: 'center' }} component="h1" variant="h5">
                            {title}
                        </Typography>
                        {!sent && <Typography sx={{ textAlign: 'center' }} component="p">
                            {subtitle}
                        </Typography>}

                        {!sent && <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
                            {inputs.map((input, index) => {
                                if (input.type === 'select') {
                                    return (
                                        <FormControl sx={{ mt: '20px' }} fullWidth key={index}>
                                            <InputLabel id={`${input.name}-label`}>{input.label}</InputLabel>
                                            <Select
                                                labelId={`${input.name}-label`}
                                                id={input.name}
                                                label={input.label}
                                                name={input.name}
                                                aria-label={input.label}
                                                required={input.required}
                                                autoComplete={input.autoComplete}
                                                autoFocus={input.autoFocus}
                                            >
                                                {input.options.map((option, index) => {
                                                    return (
                                                        <MenuItem value={option.value} key={index}>{option.label}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                    )
                                }
                                return (
                                    <TextField
                                        margin="normal"
                                        required={input.required}
                                        fullWidth
                                        type={input.type}
                                        aria-label={input.label}
                                        id={input.name}
                                        label={input.label}
                                        name={input.name}
                                        autoComplete={input.autoComplete}
                                        autoFocus={input.autoFocus}
                                        key={index}
                                        InputLabelProps={input.shrink? {shrink: true}: {}}
                                    />
                                )
                            })}
{/*                             <FormControlLabel
                                control={<Checkbox value="remember" color="primary" />}
                                label={<><span> Aceptar </span> <a target={'_blank'} href={'https://visas.atlassian.net/servicedesk/customer/portal/2/article/35946497'}>términos y condiciones</a></>}
                            /> */}

                            {!loading && <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2, background: "#1F9638" }}
                            >
                                Solicita tu admisión
                            </Button>}
                            {loading && <CircularProgress />}
                            {/* <Copyright sx={{ mt: 5 }} companyName='Intercampus' website='https://intercampus.co' /> */}
                        </Box>}
                        {sent && <Box sx={{ mt: 1 }}>
                            <Typography sx={{ textAlign: 'center' }} component="p">
                                Gracias por registrarte, recibirás un correo con tu formulario de admisión diligenciado.
                                ¡Te esperamos pronto en Canadá!
                                Recuerda que todos nuestros programas tienen PGWP (Post Graduation Work Permit).
                            </Typography>
                            <Button
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2, background: "#1F9638" }}
                                onClick={() => setSent(false)}
                            >
                                Volver
                            </Button>
                        </Box>

                        }
                    </Box>
                </Box>
            </Grid>
        </Grid>
    </ThemeProvider>
    );
}

export default ComplexForm;
